import { Injectable, Inject, InjectionToken } from "@angular/core";
import { CookieService } from "src/app/services/cookie.service";

export const WINDOW = new InjectionToken<Window>("WINDOW", { factory: () => window });

const FEATURE_BRANCH_COOKIE_NAME = "features";

@Injectable({ providedIn: "root" })
export class FeatureBranchCookieService {
  constructor(
    private readonly cookieService: CookieService,
    @Inject(WINDOW) private readonly win: Window,
  ) {}

  getFeatureBranchCookie(): string | undefined {
    return this.cookieService.getCookie(FEATURE_BRANCH_COOKIE_NAME) as string | undefined;
  }

  removeFeatureBranchCookie(): void {
    this.cookieService.deleteCookie(FEATURE_BRANCH_COOKIE_NAME, ".storebrand.no");
    this.win.location.reload();
  }
}
